// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"f32d65d521ec6157","777":"c6d704d8580b1bf5"}[chunkId] + ".js";
};